import { render, staticRenderFns } from "./DetailActionBar.vue?vue&type=template&id=23af0543&"
import script from "./DetailActionBar.vue?vue&type=script&lang=ts&"
export * from "./DetailActionBar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailActionBar.vue?vue&type=style&index=0&id=23af0543&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports